import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artists: hasMany('artist', { inverse: null }),
  assetFormatRelations: hasMany('asset-format-relation', { inverse: 'asset' }),
  assetTokenConfigs: hasMany('asset-token-config', { inverse: 'asset' }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  products: hasMany('product', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
});
